import { Link } from "react-router-dom";

export default function ProductCard({ product, index = 0 }) {
  const credit = product.author || product.instructor || "—";
  return (
    <Link
      to={`/p/${product.product_id}`}
      data-testid={`product-card-${product.product_id}`}
      className="group bg-white border border-brand-line transition-all duration-300 hover:-translate-y-1 hover:shadow-md flex flex-col"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="aspect-[3/4] overflow-hidden bg-brand-bg">
        <img
          src={product.cover_image}
          alt={product.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          style={{ objectPosition: (product.cover_image || "").includes("forged%20in%20fire") ? "right center" : "center" }}
        />
      </div>
      <div className="p-5 md:p-6 flex flex-col flex-1">
        <div className="flex items-center justify-between mb-3">
          <span className="overline text-brand-inkMuted">{product.category}</span>
          {product.badge && <span className="overline text-brand-rust">{product.badge}</span>}
        </div>
        <h3 className="font-serif text-lg md:text-xl text-brand-ink leading-snug">{product.title}</h3>
        <p className="mt-1 text-sm text-brand-inkMuted">{credit}</p>
        <div className="mt-auto pt-5 flex items-center justify-between">
          <span className="text-brand-ink font-medium">
            {product.type === "course" ? `$${Number(product.price).toFixed(2)}` : "On Amazon"}
          </span>
          <span className="overline text-brand-rust group-hover:translate-x-1 transition-transform">
            {product.type === "book" ? "View →" : "Enroll →"}
          </span>
        </div>
      </div>
    </Link>
  );
}
